<template>

  <div>

    <div class="container body">
      <div class="main_container">
        <!-- sidebar menu -->
        <div id="sidebar"></div>
        <!-- /sidebar menu -->

        <!-- top navigation -->
        <div id="header" ></div>
        <NavigaionBar v-show="stateName!='login' && stateName!='resetpassword' && stateName!='signup' && stateName!='signupconfirm'"></NavigaionBar>
        <!-- /top navigation -->

        <!-- page content -->
        <div class="container-fluid bg-body" role="main"  v-bind:style="stateName=='login' || stateName=='resetpassword' || stateName=='signup' || stateName=='signupconfirm'?'min-height:inherit !important':''">

          <router-view></router-view>

        </div>

      </div>
      <!-- /page content -->

      <!--Notification Sidebar-->
      <div id="notification_sidebar"></div>


      <!-- footer content -->
      <div id="footer"></div>
      <!-- /footer content -->
    </div>
  </div>

</template>
<script> 
  export default {
    data () {
      return {
        stateName: ''
      }
    },
    mounted () {
      let context=this
      this.stateName = this.$route.name
    },
    watch: {
      '$route' (to, from) {
        this.stateName = to.name
        if(from.name == 'login' || from.name== 'signupconfirm')
        {

          $.event.trigger({
            type: 'newMessage'

          })
        }
      }
    },
    methods: {}
  }
</script>


<style>
.el-input
{
  font-size:13px !important;
}
</style>


// WEBPACK FOOTER //
// App.vue?346219a2